import React from 'react'
import classNames from 'classnames'
import { T } from '@transifex/react'
import {
  IconLockNew20,
  Link,
} from '@lightspeed/unified-components-helios-theme/react'
import { Tooltip } from '../../../../shared/Tooltip'
import {
  usePromoCodeLabelModel,
  PromoCodeLabelProps,
} from './usePromoCodeLabelModel'

export const PromoCodeLabel: React.FC<PromoCodeLabelProps> = props => {
  const model = usePromoCodeLabelModel(props)

  if (model.disabled) {
    return (
      <span className="uc-base">
        <Tooltip
          placement="left"
          disabled={!model.tooltipInfo}
          controlSlot={
            <span
              className={classNames(
                'flex pl-4 typography-body-sm-emphasized cursor-not-allowed'
              )}
            >
              <IconLockNew20 className="mr-2" data-testid="lock-icon" />
              <T _str="Promo code" _context="Promo code link on sale footer" />
            </span>
          }
        >
          <strong>{model.tooltipInfo?.title}</strong>
          <div>{model.tooltipInfo?.message}</div>
        </Tooltip>
      </span>
    )
  }

  return (
    <span className="uc-base">
      <Link
        customClasses={{ content: ['pl-4', 'typography-body-sm-emphasized'] }}
        onClick={model.onClick}
      >
        <T _str="Promo code" _context="Promo code link on sale footer" />
      </Link>
    </span>
  )
}
